import { timelineSteps } from "@/mocks/gua";

export default function TimelineFeature() {
  return (
    <section id="timeline" className="scroll-mt-20 bg-background-100/70 py-12 md:py-16">
      <div className="wrap">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-900">
              <i className="ri-time-line" aria-hidden="true"></i>
              本周重点 · 时间线深扒
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              把「假唱」风波<span className="text-accent-600">按时间线还原一遍</span>
            </h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              事件不是一夜炸开，而是被一环一环推上去的。我们按下表把公开的时间节点逐条对齐，
              谁先发声、谁在加码、争议拐点在哪，一眼看明白。
            </p>
          </div>
        </div>

        <div className="mt-8 grid gap-6 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          {/* 左侧摘要卡 */}
          <div className="lg:sticky lg:top-24">
            <div className="relative overflow-hidden rounded-2xl border border-background-200 bg-background-50 p-6 md:p-7">
              <div className="absolute -right-6 -top-8 flex h-32 w-32 items-center justify-center rounded-full bg-primary-100 text-primary-500">
                <i className="ri-radio-line text-5xl" aria-hidden="true"></i>
              </div>
              <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
                <i className="ri-hotspot-fill" aria-hidden="true"></i>
                热度峰值 98
              </span>
              <h3 className="relative mt-4 font-heading text-xl font-bold leading-snug text-foreground-950">
                跨年直播「假唱」事件，正在从情绪之争走向技术复盘
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                六天里发生了什么？从现场弹幕质疑，到切片疯传、多方回应，再到声学报告与无剪辑录像，
                我们按时间先后把每个节点附上「依据来源」，让你不必翻几百条消息就能掌握全局。
              </p>
              <div className="mt-6 grid grid-cols-3 divide-x divide-background-200 rounded-xl border border-background-200 bg-background-100/60 py-3 text-center">
                <div>
                  <div className="font-heading text-xl font-bold text-primary-600">6</div>
                  <div className="text-xs text-foreground-500">关键节点</div>
                </div>
                <div>
                  <div className="font-heading text-xl font-bold text-accent-600">18h</div>
                  <div className="text-xs text-foreground-500">持续时间</div>
                </div>
                <div>
                  <div className="font-heading text-xl font-bold text-secondary-600">3方</div>
                  <div className="text-xs text-foreground-500">公开回应</div>
                </div>
              </div>
              <a
                href="#replay"
                className="mt-6 inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                查看完整复盘档案
                <i className="ri-arrow-right-line" aria-hidden="true"></i>
              </a>
            </div>
          </div>

          {/* 右侧时间线 */}
          <ol className="relative ml-2 flex flex-col gap-0 border-l-2 border-background-200">
            {timelineSteps.map((step, i) => (
              <li key={i} className="relative pl-7 pb-7 last:pb-0">
                <span className="absolute -left-[9px] top-1 flex h-4 w-4 items-center justify-center rounded-full bg-background-50 ring-2 ring-background-200">
                  <span className={"h-2 w-2 rounded-full " + (i === 3 || i === 5 ? "bg-accent-500" : i === 0 ? "bg-primary-500" : "bg-secondary-400")}></span>
                </span>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="whitespace-nowrap rounded-md bg-background-200 px-2 py-0.5 text-xs font-semibold text-foreground-700">{step.time}</span>
                  {i === 5 && (
                    <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-medium text-accent-800">
                      <i className="ri-flashlight-fill" aria-hidden="true"></i>
                      关键转折
                    </span>
                  )}
                  {i === 3 && (
                    <span className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900">
                      <i className="ri-fire-line" aria-hidden="true"></i>
                      热度抬升
                    </span>
                  )}
                </div>
                <h4 className="mt-2 font-heading text-base font-bold text-foreground-900">{step.title}</h4>
                <p className="mt-1 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}